import type { FaireProductEntity } from "../../entity_types/product";

export const p_c3zfjr6626: FaireProductEntity = {
  token: "p_c3zfjr6626",
  type: "product",
  name: "Metallic Accent Sea Shell Pendant Pearl Beaded Necklace",
  brandName: "The Looks by Fame Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/7b886513a2b1147af47e0fdec16bb660d2e1f89d64345b58763a0c9d794956b4.jpeg",
  priceDollars: 5.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/785e743a7c49e9cb2a8eaba6d47f0b083382da80c49d7397a15a0f6429aed032.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
